import { UiQuoteModel } from "../../models";

export function mockUiQuoteModel({
    id = "Quote-1234",
    type = "uiQuote",
    locale = "en",
    content = mockUiQuoteModelContent()
}: Partial<UiQuoteModel> = {}): UiQuoteModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiQuoteModelContent = UiQuoteModel["content"];

export function mockUiQuoteModelContent({
    entryTitle = "eBay",
    quote = "Everyone loves it; it has democratized our finance function. In some ways Trello shattered hierarchy and brought us together.",
    attribution = "__BHARATH SUNDAR__ - Finance, eBay\n\nIndustry: __eCommerce__",
    ...optionals
}: Partial<UiQuoteModelContent> = {}): UiQuoteModelContent {
    return {
        entryTitle,
        quote,
        attribution,
        ...optionals
    };
}
